import { styled } from '~/styled'

export const Day = styled('button', {
  base: [
    'bg-transparent',
    'border-none',
    'rounded-full',
    'text-grey-900',
    'cursor-pointer',
    'font-body',
    'text-sm',
    'size-8',
    'p-0',
    'transition-all',
    'duration-75',
    'hover:bg-grey-200',
    'active:bg-primary-800',
    'active:text-white',
    'focus:outline-2',
    'focus:outline-offset-2',
    'focus:outline-primary-800',
    'focus:outline-solid',
    'disabled:cursor-default',
    'disabled:opacity-30'
  ],
  variants: {
    isSelected: {
      true: ['bg-primary-800', 'hover:bg-primary-800', 'text-white']
    },
    isToday: {
      true: ['bg-grey-200']
    },
    isOutsideMonth: {
      true: ['text-grey-600']
    }
  }
})
